import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { compose } from '@/utils/story-composer';
import { CountriesEnum } from '@/enums/countries';

function CookiebotDeclaration() {
	const { i18n } = useTranslation();
	const lang = CountriesEnum.find(c => c.locale === i18n.language)?.language || 'en';
	const refElement = useRef();

	useEffect(() => {
		const script = document.createElement('script');
		script.id = 'CookieDeclaration';
		script.src = 'https://consent.cookiebot.com/d5de453d-5916-44a4-b5ed-3a13537c1d63/cd.js';
		script.type = 'text/javascript';
		script.setAttribute('data-culture', lang);
		refElement.current.appendChild(script);
	}, []);

	return <div className="prose" ref={refElement} />;
}

compose('cookiebot-declaration', CookiebotDeclaration);
export default CookiebotDeclaration;
